module.exports = "fragment GroupFragment on Group {\n  __typename\n  id\n  name\n  description\n}\n"